var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intersect"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.24485 24.0205C2.60541 27.3906 5.31595 30.1011 8.68441 30.4766C11.1864 30.7555 13.7553 30.995 16.3744 30.995C18.9936 30.995 21.5625 30.7555 24.0645 30.4766C27.4329 30.1011 30.1435 27.3906 30.504 24.0205C30.7702 21.5326 30.995 18.9784 30.995 16.3744C30.995 13.7704 30.7702 11.2163 30.504 8.72842C30.1435 5.35833 27.4329 2.64778 24.0645 2.27231C21.5625 1.99343 18.9936 1.75391 16.3744 1.75391C13.7553 1.75391 11.1864 1.99343 8.6844 2.27231C5.31594 2.64778 2.6054 5.35833 2.24484 8.72841C1.97867 11.2163 1.75391 13.7704 1.75391 16.3744C1.75391 18.9784 1.97867 21.5326 2.24485 24.0205Z",
    fill: "#0F121D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24485 24.0205C2.60541 27.3906 5.31595 30.1011 8.68441 30.4766C11.1864 30.7555 13.7553 30.995 16.3744 30.995C18.9936 30.995 21.5625 30.7555 24.0645 30.4766C27.4329 30.1011 30.1435 27.3906 30.504 24.0205C30.7702 21.5326 30.995 18.9784 30.995 16.3744C30.995 13.7704 30.7702 11.2163 30.504 8.72842C30.1435 5.35833 27.4329 2.64778 24.0645 2.27231C21.5625 1.99343 18.9936 1.75391 16.3744 1.75391C13.7553 1.75391 11.1864 1.99343 8.6844 2.27231C5.31594 2.64778 2.6054 5.35833 2.24484 8.72841C1.97867 11.2163 1.75391 13.7704 1.75391 16.3744C1.75391 18.9784 1.97867 21.5326 2.24485 24.0205Z",
    stroke: "#84C70D",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M22.2227 16.374L10.5262 16.374",
    stroke: "#84C70D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMinus);
export default __webpack_public_path__ + "static/media/product-minus.e019e1ae1763b15b325caafac7977416.svg";
export { ForwardRef as ReactComponent };